import { useState, ReactNode } from "react";
import PageChanger from "components/PageChanger";

export default function SortableTable<TRecord>(props: {
  spec: {
    columns: {
      label: string;
      sortFunc: (a: TRecord, b: TRecord) => number;
      width?: string;
      isTitle?: boolean;
    }[];
    renderRow: (record: TRecord, index: number) => ReactNode;
    pageSize?: number;
  };
  records: readonly TRecord[];
  className?: string;
}) {
  const [unclampedPageNum, setPageNum] = useState(0);
  const [sortBy, setSortBy] = useState<number | null>(null);
  const [sortReverse, setSortReverse] = useState(false);

  const { columns, renderRow, pageSize } = props.spec;
  const records = [...props.records];
  if (sortBy !== null)
    records.sort(
      (a, b) => columns[sortBy].sortFunc(a, b) * (sortReverse ? -1 : 1)
    );
  const lastPage =
    pageSize === undefined ? 0 : Math.floor((records.length - 1) / pageSize);
  const pageNum = Math.max(0, Math.min(unclampedPageNum, lastPage));
  const rows =
    pageSize === undefined
      ? records
      : records.slice(pageNum * pageSize, (pageNum + 1) * pageSize);

  if (rows.length === 0) return null;
  const table = (
    <table className={props.className}>
      <colgroup>
        {columns.map(({ width }, i) => (
          <col key={i} style={{ width }} />
        ))}
      </colgroup>
      <thead>
        <tr>
          {columns.map(({ label, isTitle }, i) => {
            const setSort = () => {
              if (i !== sortBy) {
                setSortBy(i);
                setSortReverse(false);
              } else if (sortReverse) {
                setSortBy(null);
                setSortReverse(false);
              } else setSortReverse(true);
            };
            const text =
              i !== sortBy ? (
                label
              ) : (
                <>
                  {label}&nbsp;{sortReverse ? "▲" : "▼"}
                </>
              );
            return (
              <th key={i} onClick={setSort}>
                {isTitle ? <h3>{text}</h3> : text}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>{rows.map(renderRow)}</tbody>
    </table>
  );
  if (pageSize === undefined) return table;
  return (
    <div>
      {table}
      <PageChanger
        numPerPage={pageSize}
        pageNum={pageNum}
        setPageNum={setPageNum}
        numEntries={records.length}
      />
    </div>
  );
}
